/* eslint-disable @ok/oklint/no-variable-key */
import React from 'react';
import { calc, subscribe } from '@ok/blade';
import { Skeleton, Icon } from '@ok/okd';

import { toLocale } from '@common/i18n';
import {
  EVENT_EMITTER_KEYS,
  PLACEHOLDER,
} from '@pages/currencyInfo/common/context';
import { showFloorTruncationWithPlaceholder } from '@pages/currencyInfo/common/util';

import './index.less';

class BaseInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      display: false,
      klineLastPoint: '',
      quotePrecision: 0,
    };

    this.priceListen = subscribe.listen(
      EVENT_EMITTER_KEYS.currencyPrice,
      this.setLastPrice
    );
  }

  setLastPrice = ({ price, quotePrecision }) => {
    this.setState({ klineLastPoint: price, quotePrecision });
  };

  controlDisplay = () => {
    const { display } = this.state;
    this.setState({ display: !display });
  };

  componentWillUnmount() {
    this.priceListen.remove();
  }

  render() {
    const { currencyInfo, currencyPublicInfo, loading } = this.props;
    const { display, klineLastPoint, quotePrecision } = this.state;
    const displayPrice = klineLastPoint
      ? calc.showFloorTruncation(klineLastPoint, quotePrecision)
      : PLACEHOLDER;
    const displayClassName = display ? 'data-display' : 'data-hidden';
    const arrowClassName = display ? '' : 'icon-reverse';

    const {
      coinVolume,
      marketCap,
      circulationAmount,
      distributionAmount,
      marketCapRank = PLACEHOLDER,
      priceChangePercentage24h = PLACEHOLDER,
    } = currencyPublicInfo;

    const {
      fullName = PLACEHOLDER,
      symbol = PLACEHOLDER,
      introduction,
    } = currencyInfo;
    const dataList =
      introduction?.split('\n').filter((item) => item !== '') || [];

    const coinChangeRenderText =
      currencyPublicInfo?.priceChangePercentage24h < 0
        ? toLocale('currency_base_info_decrease_tips1', {
            symbol,
            price: displayPrice,
            volume: showFloorTruncationWithPlaceholder(coinVolume),
            percentage: priceChangePercentage24h,
          })
        : toLocale('currency_base_info_increase_tips1', {
            symbol,
            price: displayPrice,
            volume: showFloorTruncationWithPlaceholder(coinVolume),
            percentage: priceChangePercentage24h,
          });

    return (
      <div className="base-info-wrapper">
        <div className="info-title">
          {toLocale('currency_base_info_title', {
            symbolFullName: fullName,
            symbol,
          })}
        </div>
        <div className="info-content">
          {loading ? (
            <Skeleton />
          ) : (
            dataList.map((item, index) => {
              return <p key={index}>{item}</p>;
            })
          )}
        </div>
        {!display && (
          <div
            className="info-control-display"
            onClick={() => {
              this.controlDisplay();
            }}
          >
            <span>{toLocale('view_all')}</span>
            <Icon className={`okds-arrow-chevron-up-md ${arrowClassName}`} />
          </div>
        )}
        {display && (
          <div className="data-title">
            {toLocale('currency_info_data_title', {
              symbolFullName: fullName,
              currencyName: symbol,
            })}
          </div>
        )}
        <div className="data-content">
          <div className={`${displayClassName}`}>
            <div>{coinChangeRenderText}</div>
            <div>
              {toLocale('currency_base_info_tips2', {
                symbol,
                rankNumber: marketCapRank,
                volumeCap: showFloorTruncationWithPlaceholder(marketCap),
              })}
            </div>
            <div>
              {toLocale('currency_base_info_tips3', {
                circulationAmount:
                  showFloorTruncationWithPlaceholder(circulationAmount),
                distributionAmount:
                  showFloorTruncationWithPlaceholder(distributionAmount),
                symbol,
              })}
            </div>
          </div>
        </div>
        {display && (
          <div
            className="info-control-display"
            onClick={() => {
              this.controlDisplay();
            }}
          >
            <span>{toLocale('currency_folder_close')}</span>
            <Icon className={`okds-arrow-chevron-up-md ${arrowClassName}`} />
          </div>
        )}
      </div>
    );
  }
}

export default BaseInfo;
